<template>
  <div>
    <div class="content">
      <base-block class="mb-0">
        <div class="text-center mt-0">
           <h3 class="mt-2">{{ practice.name ? practice.name : "" }}</h3>
          <p class="mt-2">{{ practice.description ? practice.description : "" }}</p>
        </div>
      </base-block>
      <br />
      <base-block rounded title="Test Details">
        <div class="bg-white rounded p-3 pr-3 pl-3 mb-3">
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Question Selection Type</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{ practice.test_type == 'random'? 'Random' : practice.test_type == 'default' ? 'Default' : '-'  }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Duration</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{ practice.duration ? practice.duration : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Total Question Count</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{ practice.no_of_questions ? practice.no_of_questions : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Attempts</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{ practice.attempts ? practice.attempts : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Negative Marks</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{ practice.negative_mark ? practice.negative_mark : "-" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Each Question Mark</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{
                practice.each_question_mark ? practice.each_question_mark : "-"
              }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Coding</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{ practice.has_coding == 1 ? 'Yes' : "No" }}</b>
            </p>
          </div>
          <div class="d-flex pro-det p-2">
            <p class="mb-0 w-25">Result Status</p>
            <p class="mb-0 w-25 text-right">:</p>
            <p class="mb-0 text-center w-50">
              <b>{{
                practice.result_status == 1
                  ? "Result"
                  : practice.result_status == 2
                  ? "Result & Solution"
                  : practice.result_status == 3
                  ? "No Result"
                  : "-"
              }}</b>
            </p>
          </div>
        </div>
        <br />
      </base-block>
    </div>

    
      <base-block v-if="practice.test_type == 'default'" rounded title="Test Question Details">
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Question Count</b-th>
              <b-th class="text-center">Question </b-th>
              <b-th class="text-center">Answer </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(question, index) in test_questions" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center">{{ question.no_of_questions }}</b-td>
              <b-td class="text-center">{{ question.questions.question }}</b-td>
              <b-td class="text-center">{{ question.questions.answer }}</b-td>
             
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      practice: {},
      parentTopic: "",
      topic: "",
      subtopic: "",
      questionCount: "",
      type: "",
      questionData: [],      
      test_questions: [],
    };
  },
  mounted() {
    this.getPracticeTest();
    this.getTests();
  },
  methods: {
    async getPracticeTest() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_sub/practice-tests/${this.$route.params.id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.collegeToken}` },
        })
        .then((response) => {
          console.log(response);
          if(response.data.status == "success") {
          this.practice = response.data.practice_test;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    
    async getTests() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_sub/topic-questions/${this.$route.params.id} `,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.collegeToken}` },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.test_questions = response.data.mapped_topic;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
    
  },
};
</script>


<style scoped>
dl dt {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
dl dd {
  display: inline-block;
  margin: 0px 10px;
  padding-bottom: 0;
  vertical-align: middle;
}
dl dt.green {
  background: #e5ae67;
}
dl dt.grey {
  background: #343a40;
}
dl dt.blue {
  background: #5179d6;
}
</style>